import LogoBrandSection from './LogoBrandSection.vue';

export default LogoBrandSection;
